import { gql } from "@apollo/client";

export const TransactorCompaniesV2 = gql`
  query TransactorCompaniesV2($filter: palmoil_transactor_organisation_bool_exp) {
        orgs: palmoil_transactor_organisation(where:$filter){
            organisation {
                id,
                organisation_type,
                location {
                    id,
                    village,
                    province
                   },
                positionepsg4326,
                name,
                reputation_level,
                employees {
                    transactor {
                        person {
                               firstname
                           }
                    }
                }
            }
}
}`